export const albumsData = [
  { id: 1, name: 'Занавеска', image: require('./pics/album1.jpg'), background:require('./pics/b1.jpg') },
  { id: 2, name: 'Мышонок', image:require('./pics/album2.jpg'), background:require('./pics/b2.jpg') },
  { id: 3, name: 'Синонимы к слову искренность', image:require('./pics/album3.jpg'), background:require('./pics/b3.jpg') },
  { id: 4, name: 'Синонимы к слову любовь', image:require('./pics/album4.jpg'), background:require('./pics/b4.jpg') },
  { id: 5, name: 'Знаешь, бриз', image:require('./pics/album5.jpg'), background:require('./pics/b5.jpg')},
  { id: 6, name: 'Крылья', image:require('./pics/album6.jpg'), background:require('./pics/b6.jpg')},
  { id: 7, name: 'Добраться до него', image:require('./pics/album7.jpg'), background:require('./pics/b7.jpg')},
  { id: 8, name: 'Всем одинаково холодно', image:require('./pics/album8.jpg'), background:require('./pics/b8.jpg')},
  { id: 9, name: 'Дом, баня', image:require('./pics/album9.jpg'), background:require('./pics/b9.jpg')},
  { id: 10, name: 'Русалки', image:require('./pics/album10.jpg'), background:require('./pics/b10.jpg')},
  { id: 11, name: 'Руководство по уходу за деревом', image:require('./pics/album11.jpg'), background:require('./pics/b11.jpg')},
];

export const songsData = [
    {
        id: 1,
        name: 'Человек-занавеска',
        albumid: 1,
        namealbum: 'Занавеска',
        line: 'То тянет к земле и сутулится, то вспрыгнет, затанцует вдруг',
        youtube: null,
        deezer: 'https://deezer.page.link/58gBpVdoLLprVfHL9',
        vk: 'https://vk.com/audio-173087564_456239022_84e08c10b93f69be19',
        spotify: 'https://open.spotify.com/track/0GI3lLLezgDnHwEnyzAWzI?si=ed9eeb6c9ce9416e',
        yandex: 'https://music.yandex.ru/album/9330702/track/60414891',
        apple: 'https://music.apple.com/ru/song/%D1%87%D0%B5%D0%BB%D0%BE%D0%B2%D0%B5%D0%BA-%D0%B7%D0%B0%D0%BD%D0%B0%D0%B2%D0%B5%D1%81%D0%BA%D0%B0/1491841014',
        image:require('./pics/album1.jpg'),
        background:require('./pics/b1.jpg'),
    },
    {
        id: 2,
        name: 'Остановись',
        albumid: 1,
        namealbum: 'Занавеска',
        line: 'Не бей, перестань быть цикличным, обезличенным и простодушным',
        youtube: null,
        deezer: 'https://deezer.page.link/jRxQNJJfLhDvyFMu7',
        vk: 'https://vk.com/audio-173087564_456239023_f1c5111cac88ed6173',
        spotify: 'https://open.spotify.com/track/2hZtRix0PzbMvYr8JEzJHW?si=1e91aee92b204a3f',
        yandex: 'https://music.yandex.ru/album/9330702/track/60414893',
        apple: 'https://music.apple.com/ru/album/%D0%BE%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%B8%D1%81%D1%8C/1491841013?i=1491841015',
        image:require('./pics/album1.jpg'),
        background:require('./pics/b1.jpg'),
    },
    {
        id: 3,
        name: 'Закройте',
        albumid: 1,
        namealbum: 'Занавеска',
        line: 'Апрель нас поранит, измучит и мы погибнем с вами к лету',
        youtube: null,
        deezer: 'https://deezer.page.link/yS7AFuiwwsnXdDVS7',
        vk: 'https://vk.com/audio-173087564_456239024_5df61b6fc4d4fc38af',
        spotify: 'https://open.spotify.com/track/5iUG2DpTzv0Fy1XpqYXdxB?si=aa6c3ad601884239',
        yandex: 'https://music.yandex.ru/album/9330702/track/60414895',
        apple: 'https://music.apple.com/ru/album/%D0%B7%D0%B0%D0%BA%D1%80%D0%BE%D0%B9%D1%82%D0%B5/1491841013?i=1491841016',
        image:require('./pics/album1.jpg'),
        background:require('./pics/b1.jpg'),
    },
    {
        id: 4,
        name: 'Нужно уехать',
        albumid: 1,
        namealbum: 'Занавеска',
        line: 'Нужно уехать туда, где всегда идёт дождь',
        youtube: null,
        deezer: 'https://deezer.page.link/p8WJbk1gXzJiVKaE8',
        vk: 'https://vk.com/audio-173087564_456239025_ce07d34e7a02e6d2d4',
        spotify: 'https://open.spotify.com/track/7n9Cw51dKlzHhYPf6qMqiB?si=6d6dfdedbcd94a61',
        yandex: 'https://music.yandex.ru/album/9330702/track/60414898',
        apple: 'https://music.apple.com/ru/album/%D0%BD%D1%83%D0%B6%D0%BD%D0%BE-%D1%83%D0%B5%D1%85%D0%B0%D1%82%D1%8C/1491841013?i=1491841017',
        image:require('./pics/album1.jpg'),
        background:require('./pics/b1.jpg'),
    },
    {
        id: 5,
        name: 'Мышонок',
        albumid: 2,
        namealbum: 'Мышонок',
        line: 'Глаза наверху и боятся раскрыться, бегают снизу наверх, как крысы',
        youtube: null,
        deezer: 'https://deezer.page.link/xBRAGrUBdWqMfy7k6',
        vk: 'https://vk.com/audio-173087564_456239026_2b381fe6fef256a1ec',
        spotify: 'https://open.spotify.com/track/7MyN6dOfs16DWpq21c6xR9?si=a914e74750fe4b14',
        yandex: 'https://music.yandex.ru/album/10721804/track/65961168',
        apple: 'https://music.apple.com/ru/album/%D0%BC%D1%8B%D1%88%D0%BE%D0%BD%D0%BE%D0%BA/1513100583?i=1513100797',
        image:require('./pics/album2.jpg'),
        background:require('./pics/b2.jpg'),
    },
    {
        id: 6,
        name: 'Быль',
        albumid: 3,
        namealbum: 'Синонимы к слову искренность',
        line: 'Дай мне пространство и время, дай чистоту и любовь своей сказки',
        youtube: 'https://music.youtube.com/watch?v=TulojJ4DKHQ&si=zG7TSle7K0Cfkz4v',
        deezer: 'https://deezer.page.link/MpSgrHBXGhPkwDMX9',
        vk: 'https://vk.com/audio-173087564_456239027_2258aef74f8b738894',
        spotify: 'https://open.spotify.com/track/6AycLubMR0jaqyJDeKTFcW?si=fa52a075bfe942dc',
        yandex: 'https://music.yandex.ru/album/13318174/track/75701761',
        apple: 'https://music.apple.com/ru/album/%D0%B1%D1%8B%D0%BB%D1%8C/1546834704?i=1546834707',
        image:require('./pics/album3.jpg'),
        background:require('./pics/b3.jpg'),
    },
    {
        id: 7,
        name: 'Объятия',
        albumid: 3,
        namealbum: 'Синонимы к слову искренность',
        line: 'А после любить и после спать, умным не быть, но стараться им стать',
        youtube: 'https://music.youtube.com/watch?v=9VkOpzlu_Qc&si=8XpW7GNaZ8XefZzU',
        deezer: 'https://deezer.page.link/NBZCFxz7m4LybaL56',
        vk: 'https://vk.com/audio-173087564_456239028_30992fefee0c02cf45',
        spotify: 'https://open.spotify.com/track/0ClKtKwRP5482YlspJOUGi?si=113d213267a44488',
        yandex: 'https://music.yandex.ru/album/13318174/track/75701763',
        apple: 'https://music.apple.com/ru/album/%D0%BE%D0%B1%D1%8A%D1%8F%D1%82%D0%B8%D1%8F/1546834704?i=1546834708',
        image:require('./pics/album3.jpg'),
        background:require('./pics/b3.jpg'),
    },
    {
        id: 8,
        name: 'Ирония',
        albumid: 3,
        namealbum: 'Синонимы к слову искренность',
        line: 'Мне правда нельзя теперь так сказать, но я говорю, говорю это сам',
        youtube: 'https://music.youtube.com/watch?v=aPwJ_6HgUTM&si=Xvm86ZXcaIlDFnV8',
        deezer: 'https://deezer.page.link/3NUr8HTMr9eL82fM8',
        vk: 'https://vk.com/audio-173087564_456239029_1354cd8da9f982d03f',
        spotify: 'https://open.spotify.com/track/4cIxMXQx5sNGtOW0fQV8Qb?si=33011bbea9ba46a9',
        yandex: 'https://music.yandex.ru/album/13318174/track/75701765',
        apple: 'https://music.apple.com/ru/album/%D0%B8%D1%80%D0%BE%D0%BD%D0%B8%D1%8F/1546834704?i=1546834709',
        image:require('./pics/album3.jpg'),
        background:require('./pics/b3.jpg'),
    },
    {
        id: 9,
        name: 'Дорога туда / Везде бардак',
        albumid: 3,
        namealbum: 'Синонимы к слову искренность',
        line: 'Везде бардак, а в голове хаос, я ищу причину и не могу найти',
        youtube: 'https://music.youtube.com/watch?v=G6Xk5eao0t0&si=u5SUxKylhsy6y4g5',
        deezer: 'https://deezer.page.link/LdtmB3AXf8dgkJo26',
        vk: 'https://vk.com/audio-173087564_456239030_ff3d9cb02496b395f8',
        spotify: 'https://open.spotify.com/track/2v9Ke0QFsrAOac2KZhcUct?si=407985d8774a4eaa',
        yandex: 'https://music.yandex.ru/album/13318174/track/75701766',
        apple: 'https://music.apple.com/ru/album/%D0%B4%D0%BE%D1%80%D0%BE%D0%B3%D0%B0-%D1%82%D1%83%D0%B4%D0%B0-%D0%B2%D0%B5%D0%B7%D0%B4%D0%B5-%D0%B1%D0%B0%D1%80%D0%B4%D0%B0%D0%BA/1546834704?i=1546834710',
        image:require('./pics/album3.jpg'),
        background:require('./pics/b3.jpg'),
    },
    {
        id: 10,
        name: 'Колючая палочка',
        albumid: 4,
        namealbum: 'Синонимы к слову любовь',
        line: 'Я её от себя избавлю, или себя от неё избавлю, или тебя от неё избавлю',
        youtube: 'https://music.youtube.com/watch?v=dcbgoRI56hQ&si=Xd4L2njwu--OIyDM',
        deezer: 'https://deezer.page.link/wLsyHRC3kCPcfM1S8',
        vk: 'https://vk.com/audio-173087564_456239033_b5fc28e5649fd36089',
        spotify: 'https://open.spotify.com/track/6aCIs8wMSHqEUVw4dfF2vF?si=9a6ec64c23244708',
        yandex: 'https://music.yandex.ru/album/17077654/track/88021456',
        apple: 'https://music.apple.com/ru/album/%D0%BA%D0%BE%D0%BB%D1%8E%D1%87%D0%B0%D1%8F-%D0%BF%D0%B0%D0%BB%D0%BE%D1%87%D0%BA%D0%B0/1578190663?i=1578190664',
        image:require('./pics/album4.jpg'),
        background:require('./pics/b4.jpg'),
    },
    {
        id: 11,
        name: 'Королева',
        albumid: 4,
        namealbum: 'Синонимы к слову любовь',
        line: 'Теперь всё растекается по груди в одном семицветном пятне',
        youtube: 'https://music.youtube.com/watch?v=gIPOxOVZpy8&si=usrWBj5lp12xaT3t',
        deezer: 'https://deezer.page.link/UVVkymm5PxzxN1mh7',
        vk: 'https://vk.com/audio-173087564_456239032_fa83782e3c92664758',
        spotify: 'https://open.spotify.com/track/3aj5aSh4pwEoOvBwZWPxd2?si=281da9395afc46c1',
        yandex: 'https://music.yandex.ru/album/17077654/track/88021457',
        apple: 'https://music.apple.com/ru/album/%D0%BA%D0%BE%D1%80%D0%BE%D0%BB%D0%B5%D0%B2%D0%B0/1578190663?i=1578190665',
        image:require('./pics/album4.jpg'),
        background:require('./pics/b4.jpg'),
    },
    {
        id: 12,
        name: 'Вакуум',
        albumid: 4,
        namealbum: 'Синонимы к слову любовь',
        line: 'Нас отсюда за руки вытянет счастливое утро следующего дня',
        youtube: 'https://music.youtube.com/watch?v=k9V3hk3cAGY&si=uDMEqpq_wKI4_4DC',
        deezer: 'https://deezer.page.link/MhNBhomVJVgVCfuY8',
        vk: 'https://vk.com/audio-173087564_456239031_0fdf9a60596f149a6a',
        spotify: 'https://open.spotify.com/track/7mjNmYmdlF1L7gRgJcJaR3?si=d52c028316384f45',
        yandex: 'https://music.yandex.ru/album/17077654/track/88021458',
        apple: 'https://music.apple.com/ru/album/%D0%B2%D0%B0%D0%BA%D1%83%D1%83%D0%BC/1578190663?i=1578190666',
        image:require('./pics/album4.jpg'),
        background:require('./pics/b4.jpg'),
    },
    {
        id: 13,
        name: 'Знаешь, бриз',
        albumid: 5,
        namealbum: 'Знаешь, бриз',
        line: 'На пару часов я влюблённый дальтоник, различающий только цвета любви',
        youtube: 'https://music.youtube.com/watch?v=_q9_gBEDlXI&si=7F9DwdZemwNbsXah',
        deezer: 'https://deezer.page.link/Dja1pbmv5Q1n3DjR6',
        vk: 'https://vk.com/audio-173087564_456239034_7c3a7a1a57d9dd6e52',
        spotify: 'https://open.spotify.com/track/7eXVetkwEXAMiOc88XaB0A?si=43dd6e0d60b04dd0',
        yandex: 'https://music.yandex.ru/album/21182544/track/100748880',
        apple: 'https://music.apple.com/ru/album/%D0%B7%D0%BD%D0%B0%D0%B5%D1%88%D1%8C-%D0%B1%D1%80%D0%B8%D0%B7/1608889212?i=1608889214',
        image:require('./pics/album5.jpg'),
        background:require('./pics/b5.jpg'),
    },
    {
        id: 14,
        name: 'Крылья',
        albumid: 6,
        namealbum: 'Крылья',
        line: 'Да, у меня тоже может есть крылья, но болит недостаточно сильно',
        youtube: 'https://music.youtube.com/watch?v=yv8WU3rlUTQ&si=7Q09pY7Ts3QrS8zl',
        deezer: null,
        vk: 'https://vk.com/audio-173087564_456239035_0d1ab17522efe50a00',
        spotify: 'https://open.spotify.com/track/3ub8IOyHh2nO6tvZoCa4MS?si=f17556b6a22f4388',
        yandex: 'https://music.yandex.ru/album/22442794/track/104354827',
        apple: 'https://music.apple.com/ru/album/%D0%BA%D1%80%D1%8B%D0%BB%D1%8C%D1%8F/1622254425?i=1622254426',
        image:require('./pics/album6.jpg'),
        background:require('./pics/b6.jpg'),
    },
    {
        id: 15,
        name: 'Плафон',
        albumid: 7,
        namealbum: 'Добраться до него',
        line: 'Говорит: \"я здесь, чтоб тебе не было пусто, я здесь, чтоб ты не был один\"',
        youtube: 'https://music.youtube.com/watch?v=50UQaA9U54E&si=3Y0IlwsMaLVMWMLI',
        deezer: 'https://deezer.page.link/nmT58tSGc2oY5r2VA',
        vk: 'https://vk.com/audio-173087564_456239037_1196681200767499b8',
        spotify: 'https://open.spotify.com/track/1rXMEoL72VGYfBjExRJ7hK?si=d5fb1242c70b4e3e',
        yandex: 'https://music.yandex.ru/album/23593193/track/107522080',
        apple: 'https://music.apple.com/ru/album/%D0%BF%D0%BB%D0%B0%D1%84%D0%BE%D0%BD/1646239446?i=1646239447',
        image:require('./pics/album7.jpg'),
        background:require('./pics/b7.jpg'),
    },
    {
        id: 16,
        name: 'Немерено',
        albumid: 7,
        namealbum: 'Добраться до него',
        line: 'Я любовь эту буду теплить и вынашивать так, чтоб она разрослась во мне деревом',
        youtube: 'https://music.youtube.com/watch?v=sPw-_Of_LgQ&si=NfnHpH5i9t8mUD_w',
        deezer: 'https://deezer.page.link/eTxQW5toSZbvM4Hc6',
        vk: 'https://vk.com/audio-173087564_456239038_58ae0c12810532395c',
        spotify: 'https://open.spotify.com/track/6KRiMyT78RNeatgjnI7sPM?si=70e45053e9a04211',
        yandex: 'https://music.yandex.ru/album/23593193/track/107522081',
        apple: 'https://music.apple.com/ru/album/%D0%BD%D0%B5%D0%BC%D0%B5%D1%80%D0%B5%D0%BD%D0%BE/1646239446?i=1646239448',
        image:require('./pics/album7.jpg'),
        background:require('./pics/b7.jpg'),
    },
    {
        id: 17,
        name: 'Разодрать себе грудь',
        albumid: 7,
        namealbum: 'Добраться до него',
        line: 'И мы восстанем с ним вместе, и будем любить',
        youtube: 'https://music.youtube.com/watch?v=ki3oU9kT3PY&si=1uf7Bs_qRR6YkfEg',
        deezer: 'https://deezer.page.link/KBsUhxH4ccpNb3ff7',
        vk: 'https://vk.com/audio-173087564_456239039_d43fc780acecf98904',
        spotify: 'https://open.spotify.com/track/1ldjZW7EulqsMFsh8ugBE3?si=5d997b6ab5fa44f0',
        yandex: 'https://music.yandex.ru/album/23593193/track/107522082',
        apple: 'https://music.apple.com/ru/album/%D1%80%D0%B0%D0%B7%D0%BE%D0%B4%D1%80%D0%B0%D1%82%D1%8C-%D1%81%D0%B5%D0%B1%D0%B5-%D0%B3%D1%80%D1%83%D0%B4%D1%8C/1646239446?i=1646239450',
        image:require('./pics/album7.jpg'),
        background:require('./pics/b7.jpg'),
    },
    {
        id: 18,
        name: 'Пока я тут стою',
        albumid: 7,
        namealbum: 'Добраться до него',
        line: 'Падай ко мне в объятия, я тебя подхвачу, ведь я не умею ничего больше',
        youtube: 'https://music.youtube.com/watch?v=2mE17JKoNrY&si=vgbftBRPMO8WTkyA',
        deezer: 'https://deezer.page.link/BT4VRFkbAtARgc57A',
        vk: 'https://vk.com/audio-173087564_456239040_8f0c9ff837a2558a3b',
        spotify: 'https://open.spotify.com/track/43JKHpB0a3HWTvAogpxN0y?si=6c2b3e03485c4506',
        yandex: 'https://music.yandex.ru/album/23593193/track/107522083',
        apple: 'https://music.apple.com/ru/album/%D0%BF%D0%BE%D0%BA%D0%B0-%D1%8F-%D1%82%D1%83%D1%82-%D1%81%D1%82%D0%BE%D1%8E/1646239446?i=1646239451',
        image:require('./pics/album7.jpg'),
        background:require('./pics/b7.jpg'),
    },
    {
        id: 19,
        name: 'Зло',
        albumid: 8,
        namealbum: 'Всем одинаково холодно',
        line: 'Но кто-то глядит из-под кровати морщинистым разинутым ртом',
        youtube: 'https://music.youtube.com/watch?v=OySeL9oxh30&si=e43PSov-igdZw-sw',
        deezer: 'https://deezer.page.link/ZXSq3dNk3kAehC1W9',
        vk: 'https://vk.com/audio-173087564_456239072_a4bd62e30be6acfe17',
        spotify: 'https://open.spotify.com/track/1TIzYmC2GXMD5zh0TTFveQ?si=85964c339fc64604',
        yandex: 'https://music.yandex.ru/album/27525796/track/117712410',
        apple: 'https://music.apple.com/ru/album/%D0%B7%D0%BB%D0%BE/1709086889?i=1709086890',
        image:require('./pics/album8.jpg'),
        background:require('./pics/b8.jpg'),
    },
    {
        id: 20,
        name: 'Кукушка',
        albumid: 8,
        namealbum: 'Всем одинаково холодно',
        line: 'Как ни крути, но любовь малочисленна и ей никак не хватает на всех тепла',
        youtube: 'https://music.youtube.com/watch?v=a_Nu2i9kjcU&si=EiuhO7UOunGmAI1g',
        deezer: 'https://deezer.page.link/NgVFV3hbqKNvuqPb6',
        vk: 'https://vk.com/audio-173087564_456239073_9bb0820960579b3a88',
        spotify: 'https://open.spotify.com/track/04Ltt7g3YJzD5eUw71AMwZ?si=2bde6752910f4ee1',
        yandex: 'https://music.yandex.ru/album/27525796/track/117712411',
        apple: 'https://music.apple.com/ru/album/%D0%BA%D1%83%D0%BA%D1%83%D1%88%D0%BA%D0%B0/1709086889?i=1709086891',
        image:require('./pics/album8.jpg'),
        background:require('./pics/b8.jpg'),
    },
    {
        id: 21,
        name: 'Покой',
        albumid: 8,
        namealbum: 'Всем одинаково холодно',
        line: 'А то всё пройдёт и боль не сведёт с ума, и куда же тогда я тебя поведу',
        youtube: 'https://music.youtube.com/watch?v=FcBcYyiquAo&si=EKBeFfWz852QuTFC',
        deezer: 'https://deezer.page.link/ps8c2xzAJZmuPEU26',
        vk: 'https://vk.com/audio-173087564_456239074_87c1643fe4c43cf383',
        spotify: 'https://open.spotify.com/track/15ghafzplI5k5H39yprrDs?si=7c19f48fbd294568',
        yandex: 'https://music.yandex.ru/album/27525796/track/117712412',
        apple: 'https://music.apple.com/ru/album/%D0%BF%D0%BE%D0%BA%D0%BE%D0%B9/1709086889?i=1709086892',
        image:require('./pics/album8.jpg'),
        background:require('./pics/b8.jpg'),
    },
    {
        id: 22,
        name: 'Боль',
        albumid: 8,
        namealbum: 'Всем одинаково холодно',
        line: 'Бесконечная боль, боль, она не уйдёт',
        youtube: 'https://music.youtube.com/watch?v=Gn04VVX2sFU&si=YD5t5HLEOZYa5fja',
        deezer: 'https://deezer.page.link/Nrv47re55xVyRHXU6',
        vk: 'https://vk.com/audio-173087564_456239071_b44ea0968a058e24ca',
        spotify: 'https://open.spotify.com/track/5rp3pBekvSHuoml5hLJNSC?si=04f03338d8034a16',
        yandex: 'https://music.yandex.ru/album/27525796/track/117712413',
        apple: 'https://music.apple.com/ru/album/%D0%B1%D0%BE%D0%BB%D1%8C/1709086889?i=1709086893',
        image:require('./pics/album8.jpg'),
        background:require('./pics/b8.jpg'),
    },
    {
        id: 23,
        name: 'Холодно',
        albumid: 8,
        namealbum: 'Всем одинаково холодно',
        line: 'Мне снится кошмар, когда ноги в холоде, а по полу дует открытый сквозняк',
        youtube: 'https://music.youtube.com/watch?v=Fp54vTi5kW0&si=435zGHXYXwLnHBP6',
        deezer: 'https://deezer.page.link/5eZUT5mW3XyjDmii8',
        vk: 'https://vk.com/audio-173087564_456239075_965be741db97f9de5c',
        spotify: 'https://open.spotify.com/track/1gTyP9Pn8FsNFuCPRMdDic?si=cc72670a23f54087',
        yandex: 'https://music.yandex.ru/album/27525796/track/117712414',
        apple: 'https://music.apple.com/ru/album/%D1%85%D0%BE%D0%BB%D0%BE%D0%B4%D0%BD%D0%BE/1709086889?i=1709086894',
        image:require('./pics/album8.jpg'),
        background:require('./pics/b8.jpg'),
    },
    {
        id: 24,
        name: 'Дом, баня',
        albumid: 9,
        namealbum: 'Дом, баня',
        line: 'И щёки горят, и места родного так много, так много, я рад',
        youtube: 'https://music.youtube.com/watch?v=gQThgwnTuVQ&si=OyuBUHKyenWc3LWl',
        deezer: 'https://deezer.page.link/beaBUHX5eu762EdR6',
        vk: 'https://vk.com/audio-173087564_456239077_f9e0bff9765615842b',
        spotify: 'https://open.spotify.com/track/0cJA2JFYLFx7pe89zxr3gA?si=090b3d3206c243a2',
        yandex: 'https://music.yandex.ru/album/31987266/track/127871722',
        apple: 'https://music.apple.com/ru/album/%D0%B4%D0%BE%D0%BC-%D0%B1%D0%B0%D0%BD%D1%8F/1754751317?i=1754751318',
        image:require('./pics/album9.jpg'),
        background:require('./pics/b9.jpg'),
    },
    {
        id: 25,
        name: 'Русалки',
        albumid: 10,
        namealbum: 'Русалки',
        line: 'На ногах трясина, за спиной болото, тятю потопила и тебя потопит',
        youtube: 'https://music.youtube.com/watch?v=FwSWzaG7JvI&si=Yu_L6X6mkzEloqaV',
        deezer: 'https://deezer.page.link/tAy2dCJvrad3nCUQ7',
        vk: 'https://vk.com/audio-173087564_456239078_10da65db7daca3d82f',
        spotify: 'https://open.spotify.com/track/6LrljRpHJLPPGZdznItuqZ?si=9a54003eb329407c',
        yandex: 'https://music.yandex.ru/album/33853345/track/132346768',
        apple: 'https://music.apple.com/ru/album/%D1%80%D1%83%D1%81%D0%B0%D0%BB%D0%BA%D0%B8/1775960755?i=1775960756',
        image:require('./pics/album10.jpg'),
        background:require('./pics/b10.jpg'),
    },
    {
        id: 26,
        name: 'Цель',
        albumid: 11,
        namealbum: 'Руководство по уходу за деревом',
        line: 'Ты вызвала меня на дуэль, и это единственная моя цель',
        youtube: 'https://music.youtube.com/watch?v=hW_TvY33KXI&si=CQDiokopBkthQl2S',
        deezer: 'https://dzr.page.link/KMC4t5TBUiirpJmn9',
        vk: 'https://vk.com/audio-2001671897_134671897',
        spotify: 'https://open.spotify.com/track/6sh93iVU4qU5nfiUEAIE3E?si=a7b68fb7189b47b8',
        yandex: 'https://music.yandex.ru/album/35544104/track/136439018?utm_source=desktop&utm_medium=copy_link',
        apple: 'https://music.apple.com/ru/album/%D1%86%D0%B5%D0%BB%D1%8C/1797937087?i=1797937088',
        image:require('./pics/album11.jpg'),
        background:require('./pics/b11.jpg'),
    },
    {
        id: 27,
        name: 'То ли',
        albumid: 11,
        namealbum: 'Руководство по уходу за деревом',
        line: 'То ли всё рушится, то ли я сам внутри ничего не могу построить',
        youtube: 'https://music.youtube.com/watch?v=ngF6-V3r89I&si=ejHJoSGBeOSNoAzH',
        deezer: 'https://dzr.page.link/VamASUTnnEm5wRZi7',
        vk: 'https://vk.com/audio-2001671896_134671896',
        spotify: 'https://open.spotify.com/track/7wLSbsTUzPjLtq9GVXj7Ua?si=8cc07ca02d5648d2',
        yandex: 'https://music.yandex.ru/album/35544104/track/136439019?utm_source=desktop&utm_medium=copy_link',
        apple: 'https://music.apple.com/ru/album/%D1%82%D0%BE-%D0%BB%D0%B8/1797937087?i=1797937090',
        image:require('./pics/album11.jpg'),
        background:require('./pics/b11.jpg'),
    },
    {
        id: 28,
        name: 'Так ли просила ты',
        albumid: 11,
        namealbum: 'Руководство по уходу за деревом',
        line: 'На память возьми и оставь что-нибудь, хоть что-нибудь',
        youtube: 'https://music.youtube.com/watch?v=svrjWmUFGds&si=4pklv7RT96y9Yp5J',
        deezer: 'https://dzr.page.link/EdjisTnYrvSKb26N9',
        vk: 'https://vk.com/audio-2001671894_134671894',
        spotify: 'https://open.spotify.com/track/6d3Iyrm03wRAecph5vg82g?si=219cdfa327ab4b1b',
        yandex: 'https://music.yandex.ru/album/35544104/track/136439020?utm_source=desktop&utm_medium=copy_link',
        apple: 'https://music.apple.com/ru/album/%D1%82%D0%B0%D0%BA-%D0%BB%D0%B8-%D0%BF%D1%80%D0%BE%D1%81%D0%B8%D0%BB%D0%B0-%D1%82%D1%8B/1797937087?i=1797937091',
        image:require('./pics/album11.jpg'),
        background:require('./pics/b11.jpg'),
    },
    {
        id: 29,
        name: 'Не приходила бы',
        albumid: 11,
        namealbum: 'Руководство по уходу за деревом',
        line: 'Хочется выть, я не смог забыть красоту внутри головы',
        youtube: 'https://music.youtube.com/watch?v=nM52UaoAp_U&si=eQu2rw1Bsy_IjRQ5',
        deezer: 'https://dzr.page.link/1VSvi9iDCoCu5PW76',
        vk: 'https://vk.com/audio-2001671891_134671891',
        spotify: 'https://open.spotify.com/track/30ZSFA55RDQv2pDeQ17pv1?si=123295e4ecb042d5',
        yandex: 'https://music.yandex.ru/album/35544104/track/136439021?utm_source=desktop&utm_medium=copy_link',
        apple: 'https://music.apple.com/ru/album/%D0%BD%D0%B5-%D0%BF%D1%80%D0%B8%D1%85%D0%BE%D0%B4%D0%B8%D0%BB%D0%B0-%D0%B1%D1%8B/1797937087?i=1797937092',
        image:require('./pics/album11.jpg'),
        background:require('./pics/b11.jpg'),
    }
];